export default __webpack_public_path__ + "static/media/back.e3010c6b.svg";